var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ToolbarType, LanguageMode } from '@i18nspect/types';
import { getToolbar } from '../../state';
import { TextWrapper } from './components/TextWrapper';
import { pseudolocalize } from './pseudolocalization';
import { teaCollectKey } from './init/keyCollection';
import { initI18nspect } from './init';
import bridge from '../../bridge';
import { getFinalNamespaceList, storeReverseIndex } from './utils';
import { injectStringMethodsNoops } from '../../utils/components';
import { getNamespaceMap } from './init/utils';
import state from './state';
// const elementTypesInDateMode = ['OtherModeTextWrapper', 'DateWrapper'];
// const elementTypesInNumberMode = ['OtherModeTextWrapper', 'NumberWrapper'];
export var i18nspectPostProcessor = function (_a) {
    var _b = _a.enable, enable = _b === void 0 ? true : _b, _c = _a.isMobile, isMobile = _c === void 0 ? false : _c, options = _a.options;
    if (enable) {
        initI18nspect(options);
    }
    state.namespaceMap = getNamespaceMap(options.starling.projects);
    return {
        name: 'i18nspect',
        type: 'postProcessor',
        process: function (value, key, params, translator) {
            var _a;
            try {
                var textKey = Array.isArray(key) ? key[0] : key;
                var finalNamespace = getFinalNamespaceList({
                    ns: (_a = params.ns) !== null && _a !== void 0 ? _a : translator.options.defaultNS,
                    fallbackNS: translator.options.fallbackNS,
                });
                var collectKeyPayload = {
                    key: textKey,
                    namespace: finalNamespace,
                    projectAndNamespace: finalNamespace,
                };
                var toolbar_1 = getToolbar();
                if (!toolbar_1) {
                    teaCollectKey(__assign(__assign({}, collectKeyPayload), { language: translator.language }));
                }
                storeReverseIndex({ key: textKey, value: value });
                if (enable) {
                    switch (toolbar_1 === null || toolbar_1 === void 0 ? void 0 : toolbar_1.type) {
                        case ToolbarType.Language: {
                            bridge.language.collectKey(collectKeyPayload);
                            switch (toolbar_1.mode) {
                                case LanguageMode.Inspector:
                                    return injectStringMethodsNoops(_jsx(TextWrapper, { finalNamespace: finalNamespace, textKey: textKey, originalValue: value, params: params, isMobile: isMobile }), textKey);
                                case LanguageMode.Pseudolocalization:
                                    return pseudolocalize({ value: value, textKey: textKey });
                                default:
                                    return value;
                            }
                        }
                        // Deprecated
                        case ToolbarType.Date:
                        case ToolbarType.Number: {
                            break;
                            // return injectStringMethodsNoops(
                            //   // @ts-expect-error might return string
                            //   <OtherModeTextWrapper
                            //     // t={i18n.t.bind(i18n)}
                            //     textKey={textKey}
                            //     params={params}
                            //     originalValue={value}
                            //     elementTypes={
                            //       toolbar?.type === ToolbarType.Date
                            //         ? elementTypesInDateMode
                            //         : elementTypesInNumberMode
                            //     }
                            //   />,
                            //   textKey
                            // );
                        }
                    }
                }
            }
            catch (e) {
                console.error('i18nspect post processor error', e);
            }
            return value;
        },
    };
};
i18nspectPostProcessor.__name__ = 'i18nspect';
export { withTransI18nspect } from './HOC';
